import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Using the React Fiber tree to traverse up the DOM and check if a node is within a specific component
// and extract child component props if needed.
export function checkWithinComponentAndExtractChildProps(node, targetComponentName, childComponentConfig) {
  // Get the React fiber from the DOM node
  var key = Object.keys(node).find(function (key) {
    return key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$');
  });
  if (!key) {
    return {
      isWithin: false
    };
  }
  var fiber = node[key];
  if (!fiber) {
    return {
      isWithin: false
    };
  }

  // Traverse up the fiber tree
  var currentFiber = fiber;
  var childProp;
  while (currentFiber) {
    var componentName = void 0;
    if (currentFiber.type) {
      if (typeof currentFiber.type === 'function') {
        componentName = currentFiber.type.displayName || currentFiber.type.name;
      } else if (_typeof(currentFiber.type) === 'object' && (currentFiber.type.displayName || currentFiber.type.name)) {
        componentName = currentFiber.type.displayName || currentFiber.type.name;
      }
    }

    // Check if this is a child component we're looking for
    if (childComponentConfig && componentName === childComponentConfig.componentName) {
      var props = currentFiber.memoizedProps || currentFiber.pendingProps;
      if (props && props[childComponentConfig.propName] !== undefined) {
        // Overwrite with the nearest child prop (closest to the target component)
        childProp = childComponentConfig.extractValue ? childComponentConfig.extractValue(props) : props[childComponentConfig.propName];
      }
    }

    // Check if we found the target component
    if (componentName === targetComponentName) {
      return _objectSpread({
        isWithin: true
      }, childComponentConfig && {
        childProp: childProp
      });
    }
    currentFiber = currentFiber.return;
  }
  return {
    isWithin: false
  };
}

// Check if the node is within a UFOThirdPartySegment and extract any UFOIgnoreHolds reason
export function checkThirdPartySegmentWithIgnoreReason(node) {
  var result = checkWithinComponentAndExtractChildProps(node, 'UFOThirdPartySegment', {
    componentName: 'UFOIgnoreHolds',
    propName: 'reason'
  });
  return {
    isWithinThirdPartySegment: result.isWithin,
    ignoredReason: result.childProp
  };
}

// Helper function to create mutation type from UFOIgnoreHoldsReason
export function createMutationTypeWithIgnoredReason(reason) {
  return "mutation:".concat(reason);
}